import { MAX_CAPPED_INCOME, MAX_STUDENT_AGE, pricingPercentageMap, PRICE_REDUCTION_MAX_AGE, MIN_CAPPED_INCOME, MIN_CAPPED_SELF_EMPLOYED_INCOME, studentPricing, } from './pricingFactors';
import { roundToTwoDecimal, convertPercentageToDecimal } from './util';
export { INSURERS } from './constants';
var getPriceAmount = function (income, pricePercentage) {
    return roundToTwoDecimal(income * convertPercentageToDecimal(pricePercentage));
};
export { MAX_CAPPED_INCOME, MIN_CAPPED_INCOME, MIN_CAPPED_SELF_EMPLOYED_INCOME, };
export var getContributionPrices = function (options) {
    var provider = options.provider, employmentStatus = options.employmentStatus, age = options.age, monthlyIncome = options.monthlyIncome, haveChildren = options.haveChildren;
    var cappedIncome = Math.min(monthlyIncome, MAX_CAPPED_INCOME);
    var income = employmentStatus === 'SELF_EMPLOYED'
        ? Math.max(MIN_CAPPED_SELF_EMPLOYED_INCOME, cappedIncome)
        : cappedIncome;
    var isUnderMaxAgeOrHasChild = age <= PRICE_REDUCTION_MAX_AGE || haveChildren;
    if (employmentStatus === 'EMPLOYED' || employmentStatus === 'SELF_EMPLOYED') {
        // Employed customer with income lower than minimum cannot be calculated through this engine
        if (employmentStatus === 'EMPLOYED' && income < MIN_CAPPED_INCOME) {
            return undefined;
        }
        var longTermCarePercentage = isUnderMaxAgeOrHasChild
            ? pricingPercentageMap[employmentStatus].longTermCare.reduced
            : pricingPercentageMap[employmentStatus].longTermCare.notReduced;
        var healthInsuranceAmount = getPriceAmount(income, pricingPercentageMap[employmentStatus].healthInsurance);
        var additionalAmount = getPriceAmount(income, pricingPercentageMap[employmentStatus].additional(provider));
        var longTermCareAmount = getPriceAmount(income, longTermCarePercentage);
        var total = healthInsuranceAmount + additionalAmount + longTermCareAmount;
        return {
            healthInsurance: {
                amount: healthInsuranceAmount,
                percentage: pricingPercentageMap[employmentStatus].healthInsurance,
            },
            additional: {
                amount: additionalAmount,
                percentage: pricingPercentageMap[employmentStatus].additional(provider),
            },
            longTermCare: {
                amount: longTermCareAmount,
                percentage: longTermCarePercentage,
            },
            total: roundToTwoDecimal(total),
        };
    }
    if (employmentStatus === 'STUDENT') {
        // Students older than max student age cannot find calculation through this engine
        if (age > MAX_STUDENT_AGE) {
            return undefined;
        }
        var additionalAmount = studentPricing.additional(provider);
        var longTermCarePricing = isUnderMaxAgeOrHasChild
            ? studentPricing.longTermCare.reduced
            : studentPricing.longTermCare.notReduced;
        var total = studentPricing.healthInsurance + additionalAmount + longTermCarePricing;
        return {
            healthInsurance: {
                amount: studentPricing.healthInsurance,
            },
            additional: {
                amount: additionalAmount,
            },
            longTermCare: {
                amount: longTermCarePricing,
            },
            total: roundToTwoDecimal(total),
        };
    }
    return undefined;
};
